<div class="error-page-wrapper">
    <div class="twoline">
        <div class="text-prop">
            404
        </div>
        <div class="page-div">The Page</div>
    </div>
    <div class="notfound">
        Not Found
    </div>
</div>